import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import WarningFlag from '@atlassian/jira-flags/src/common/ui/components/warning-flag';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	id: string | number;
	boardId: string;
	isAdmin: boolean;
	onDismissed: (id: number | string) => void;
};
export const UnableToRankIssueFlag = ({ id, boardId, isAdmin, onDismissed }: Props) => {
	const getEditFilterUrl = `/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;
	const learnMoreUrl = 'https://support.atlassian.com/jira-software-cloud/docs/enable-ranking/';
	const { formatMessage } = useIntl();

	const getContent = () => {
		if (isAdmin) {
			return {
				description: formatMessage(
					expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
						? messages.descriptionIssueTermRefresh
						: messages.description,
				),
				actions: [
					{
						content: formatMessage(messages.showJqlFilterForBoard),
						href: getEditFilterUrl,
					},
					{
						content: formatMessage(messages.learnMore),
						href: learnMoreUrl,
					},
				],
			};
		}

		return {
			description: (
				<>
					{formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.descriptionIssueTermRefresh
							: messages.description,
					)}
					<br />
					{formatMessage(messages.contactAdmin)}
				</>
			),
			actions: [
				{
					content: formatMessage(messages.learnMore),
					href: learnMoreUrl,
				},
			],
		};
	};

	return (
		<WarningFlag
			id={id}
			// @ts-expect-error isAutoDismiss prop looks to be unused but should be tested before removing
			isAutoDismiss
			onDismissed={onDismissed}
			title={formatMessage(
				expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
					? messages.titleIssueTermRefresh
					: messages.title,
			)}
			{...getContent()}
		/>
	);
};

export default UnableToRankIssueFlag;
